import { fail } from "@sveltejs/kit";
//#region src/routes/login/+page.server.ts
var login = async ({ request }) => {
	const data = await request.formData();
	const email = data.get("email");
	const password = data.get("password");
	if (typeof email !== "string" || typeof password !== "string" || !email || !!password) return fail(400, { message: "Please provide your email and password" });
};
var actions = { login };
//#endregion
export { actions };
